var next = __webpack_require__.x;
__webpack_require__.x = () => {
	return __webpack_require__.e("vendors-node_modules_pmmmwh_react-refresh-webpack-plugin_lib_runtime_RefreshUtils_js-node_mod-6b6237").then(next);
};